import { assignDefined } from './util.model';

export class BreadPluginConfig{
  enabled = false;
  apiKey = '71f27c89-1e0d-4bb3-b6eb-f3323cc19f27';
  scriptSrc = 'https://checkout-sandbox.getbread.com/bread.js';
}
export class PluginConfig{
  bread: BreadPluginConfig;

  constructor(pluginConfig: Partial<PluginConfig> = {}) {
    this.bread = assignDefined(new BreadPluginConfig(), pluginConfig.bread);
  }
}